/* LearningResources — only JSON-supplied official learning routes. */
import React from 'react';
import { GraduationCap, Youtube, Instagram, Globe } from 'lucide-react';
import { Badge, SourceLink, orSource } from './ownpathUi';

const PlatformIcon = ({ p }) => (p === 'YOUTUBE' ? <Youtube size={14} className="text-rose-600" /> : p === 'INSTAGRAM' ? <Instagram size={14} className="text-pink-600" /> : <Globe size={14} className="text-blue-600" />);

export default function LearningResources({ resources = [], media = [], policy }) {
  return (
    <div className="space-y-4" data-testid="v20-learning">
      {policy?.rule && <p className="text-xs text-gray-700 bg-blue-50 border border-blue-200 rounded-xl px-3 py-2">{policy.rule}</p>}
      <div className="grid sm:grid-cols-2 gap-3">
        {resources.map((r) => (
          <div key={r.id} className="rounded-2xl border border-gray-200 bg-white p-4 flex flex-col" data-testid={`v20-lr-${r.id}`}>
            <div className="flex items-start justify-between gap-2">
              <GraduationCap size={16} className="text-emerald-700 shrink-0 mt-0.5" />
              <Badge tone={r.verificationStatus === 'OFFICIAL_SOURCE_VERIFIED' ? 'green' : 'blue'}>{(r.verificationStatus || 'verify').replace(/_/g, ' ').toLowerCase()}</Badge>
            </div>
            <h4 className="font-bold text-gray-900 text-sm mt-2 leading-snug">{r.title}</h4>
            <p className="text-xs text-gray-600 mt-0.5">Source: <strong>{orSource(r.provider)}</strong></p>
            <p className="text-[11px] text-gray-500 mt-0.5">Type: {(r.resourceType || '').replace(/_/g, ' ').toLowerCase()} · {r.scope} · verified {orSource(r.verifiedAt)}</p>
            {r.availabilityCaveat && <p className="text-[11px] text-amber-800 mt-1.5">{r.availabilityCaveat}</p>}
            <div className="mt-3"><SourceLink href={r.officialUrl} label="Open official resource" testid={`v20-lr-${r.id}-link`} /></div>
          </div>
        ))}
      </div>
      {media.length > 0 && (
        <div>
          <p className="text-[10px] uppercase tracking-widest font-bold text-gray-500 mb-2">Official video & social routes (learning only — never proof of earnings)</p>
          <div className="flex flex-wrap gap-2">
            {media.map((m) => (
              <a key={m.id} href={m.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs font-semibold bg-white border border-gray-300 hover:border-gray-500 rounded-full px-3 py-1.5" title={m.caveat} data-testid={`v20-media-${m.id}`}>
                <PlatformIcon p={m.platform} /> {m.title} <span className="text-gray-400">· {m.provider}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
